import { PublicLayout } from "@/components/PublicLayout";

const CONTENT = {
  terms: {
    title: "Terms & Conditions",
    sections: [
      ["Acceptance of Terms", "By accessing and using Saad IPTV, you agree to be bound by these Terms & Conditions. If you do not agree, please discontinue use of our service."],
      ["Service Description", "Saad IPTV provides a subscription-based streaming service delivering access to live channels and on-demand content. Service availability may vary based on your internet connection and device."],
      ["Account Responsibility", "You are responsible for maintaining the confidentiality of your login credentials. Sharing credentials beyond your plan's allowed device limit may result in suspension."],
      ["Acceptable Use", "You agree not to resell, redistribute, or publicly rebroadcast the service. Any misuse may result in immediate termination without refund."],
      ["Intellectual Property", "Saad IPTV is an independent service and is not affiliated with, endorsed by, or sponsored by any broadcaster or streaming platform. All third-party trademarks belong to their respective owners."],
      ["Modifications", "We reserve the right to update these terms at any time. Continued use after changes constitutes acceptance of the revised terms."],
    ],
  },
  privacy: {
    title: "Privacy Policy",
    sections: [
      ["Information We Collect", "We collect the information you provide during registration and checkout, including your name, email and phone number, to deliver and support your subscription."],
      ["How We Use Your Data", "Your data is used solely to process orders, activate subscriptions, send service notifications and provide customer support. We never sell your personal information."],
      ["Data Security", "We use industry-standard measures including encryption and hashed passwords to protect your account. Access is restricted to authorized personnel only."],
      ["Cookies & Local Storage", "We use local storage to keep you logged in and improve your experience. No tracking data is shared with third parties."],
      ["Your Rights", "You may request access to, correction of, or deletion of your personal data at any time by contacting our support team."],
      ["Contact", "For any privacy-related questions, reach out to us through our Contact page or WhatsApp."],
    ],
  },
  refund: {
    title: "Refund Policy",
    sections: [
      ["Our Commitment", "We want you to enjoy Saad IPTV with confidence. If something isn't working, our support team will always try to resolve it first."],
      ["Eligibility", "Refund requests are eligible within 24 hours of activation, provided the service could not be delivered or a persistent technical issue remains unresolved by our support team."],
      ["Non-Refundable Cases", "Refunds are not provided for issues caused by the customer's internet connection, incompatible hardware, or after significant usage of the subscription."],
      ["How to Request", "To request a refund, contact us via WhatsApp or the Contact page with your order ID. Our team will review and respond within 48 hours."],
      ["Processing", "Approved refunds are processed to the original payment method and may take 5–10 business days to appear, depending on your provider."],
    ],
  },
};

export default function Legal({ type }) {
  const data = CONTENT[type] || CONTENT.terms;
  return (
    <PublicLayout>
      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-24">
        <h1 className="font-heading text-4xl font-extrabold text-white mb-3">{data.title}</h1>
        <p className="text-sm text-slate-500 mb-10">Last updated: {new Date().toLocaleDateString()}</p>
        <div className="space-y-8">
          {data.sections.map(([h, p], i) => (
            <div key={i} className="glass rounded-2xl p-6">
              <h2 className="font-heading text-lg font-semibold text-white mb-2">{i + 1}. {h}</h2>
              <p className="text-sm text-slate-400 leading-relaxed">{p}</p>
            </div>
          ))}
        </div>
      </section>
    </PublicLayout>
  );
}
